// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"558":"f3fe5388","908":"cab75eb9","929":"1ef3dabb"}[chunkId] + ".chunk.css";
};